/** @format */

import React, { useState, useEffect } from "react";
import useSettings from "stores/settings";
import Modal from "react-awesome-modal";
import { PhoneNumberValidator } from "components/Function";
import { BasicAlert, SuccessAlert } from "components/Alert";
import TextField from "@material-ui/core/TextField";
import { useRouter } from "next/router";

import { projectFirestore } from "components/ProjectFirestore";
import { projectStorage } from "components/ProjectStorage";
import TextMaskCustom from "./profilePhone";
import { PageTokenCheck } from "function/PageTokenCheck";
import * as jwt from "jsonwebtoken";
import Wallpaper from "@material-ui/icons/Wallpaper";

const Profile = () => {
  const settings = useSettings();
  const router = useRouter();
  const [data, setData] = useState(null);

  /* 로그인 체크 : url 이동 */
  useEffect(() => {
    PageTokenCheck(settings, router);
  }, []);

  const { email } = settings;

  useEffect(() => {
    if (email)
      try {
        const docRef = projectFirestore.collection("users").doc(`${email}`);

        docRef
          .get()
          .then((doc) => {
            if (doc.exists) {
              setData(doc.data());
            }
          })
          .catch((error) => {
            console.log("Error getting document:", error);
            BasicAlert(error);
          });
      } catch (error) {
        console.error(error);
      }
  }, [email]);

  return (
    <div className="border-table">
      <ProfileForm data={data} />
    </div>
  );
};

/* 디테일 페이지 상단 메뉴 */
const ProfileForm = ({ data }) => {
  const settings = useSettings();
  // 모달 값 저장
  const [modalVisible, setModalVisible] = useState(false);

  const [myName, setMyName] = useState();
  const [myPhone, setMyPhone] = useState();
  const [myPhoto, setMyPhoto] = useState();

  const [file, setFile] = useState();

  useEffect(() => {
    if (data) {
      const { name, photo, phone } = data;

      /* 기존 정산정보 저장 */
      setMyName(name);
      setMyPhone(phone);
      setMyPhoto(photo);
    }
  }, [data]);

  /* 기본사진 버튼 클릭 */
  const handleBasicPhotoClick = () => {
    /* input value 값을 지워줘야 동일한 파일이 올라올 때 이벤트 발생함. */
    document.getElementById("imageFileId").value = "";
    setMyPhoto("");
    setFile();
  };

  /* 사진변경 버튼 클릭 */
  const handlePhotoChange = (e) => {
    setFile(e.target.files[0]);
  };

  /* profile 정보 업데이트 */
  const handleProfileUpdate = async () => {
    const email = settings.email;

    // 닉네임 체크
    if (!myName) {
      BasicAlert("닉네임을 입력해주세요.");
      return;
    }

    if (myName.length > 15) {
      BasicAlert("닉네임은 한글, 영문 15자 이내의 자리수만 입력할 수 있습니다.");
      return;
    }

    // 전화번호 유효성 체크
    if (myPhone) {
      if (!PhoneNumberValidator(myPhone)) {
        BasicAlert("전화번호를 다시 입력해주세요.");
        return;
      }
    }

    const storageFilePath = `users/${email}/profile.jpg`;
    const storageFileRef = projectStorage.ref(storageFilePath);
    /* 변경한 사진이 있다면 */
    /* 새로운 프로필 사진 등록 */
    if (file) {
      storageFileRef.put(file).on(
        "state_changed",
        (snap) => {
          let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
          console.log(percentage);
          // setProgress(percentage);
        },
        (err) => {
          console.log("err :: ", err);
        },
        async () => {
          const url = await storageFileRef.getDownloadURL();
          /* 사진정보 업데이트 */
          try {
            const docRef = projectFirestore.collection("users").doc(`${email}`);
            await docRef.update({
              photo: url,
            });
          } catch (error) {
            console.error(error);
          }
          /* mobx에도 저장 */
          settings.photo = url;
        }
      );
    } else {
      if (myPhoto === "") {
        /* 사진정보 업데이트 */
        try {
          const docRef = projectFirestore.collection("users").doc(`${email}`);
          await docRef.update({
            photo: "",
          });
        } catch (error) {
          console.error(error);
        }
        /* mobx에도 저장 */
        settings.photo = "";
      }
    }

    /* 프로필 정보 업데이트 */
    try {
      const docRef = projectFirestore.collection("users").doc(`${email}`);
      await docRef
        .update({
          name: myName,
          phone: myPhone ? myPhone : "",
        })
        .then(() => {
          /* token or setting값 도 바꾸기 */
          settings.name = myName;
          const tokenValue = jwt.sign({ email, name: myName, uid }, process.env.SECRET_CODE, {
            expiresIn: "1d",
          });

          window.localStorage.setItem("aisoToken", tokenValue);

          const text = "적용되었습니다.";
          SuccessAlert(text);
          return;
        });
    } catch (error) {
      console.error(error);
    }
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleModalOkButton = () => {
    setModalVisible(false);
    handleProfileUpdate();
  };

  return (
    <div className="lg:px-40 xl:px-52">
      {/* 프로필 사진 */}
      <label className="col-form-label w-full">프로필 사진</label>
      <div className="flex flex-col">
        <div className="center">
          {file ? (
            <div className="img-cover-box rounded-full border min-w-min h-20 w-20  sm:w-28 sm:h-28">
              <img className="rounded-full " src={URL.createObjectURL(file)} alt="" />
            </div>
          ) : (
            <div className="img-cover-box rounded-full border min-w-min h-20 w-20 center  sm:w-28 sm:h-28">
              {myPhoto === "" ? (
                <Wallpaper style={{ width: "80%", height: "80%" }} />
              ) : (
                <img className="rounded-full" src={myPhoto} alt="" />
              )}
            </div>
          )}
        </div>
        <div className="flex justify-center items-center mt-3">
          <div className="px-1">
            <button className="relative btn glass_in_outline_btn cursor-pointer" onClick={handleBasicPhotoClick}>
              <label className="m-0 p-0 cursor-pointer" htmlFor="customFile">
                기본사진
              </label>
            </button>
          </div>
          <div className="px-1">
            <button className="relative btn glass_in_outline_btn cursor-pointer">
              <input
                type="file"
                className="custom-file-input cursor-pointer"
                id="imageFileId"
                accept="image/png, image/jpeg"
                onChange={(e) => handlePhotoChange(e)}
              ></input>
              <label className="m-0 p-0 cursor-pointer" htmlFor="customFile">
                사진변경
              </label>
            </button>
          </div>
        </div>
      </div>
      {/* 별명 */}
      {/* <div className="my-3">
        <TextField
          
          label="별명"
          placeholder="별명 입력"
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          className="my-3"
          value={myName}
          onChange={(e) => setMyName(e.target.value)}
        />
      </div> */}
      {/* 닉네임 */}
      <div className="my-3">
        <TextField
          label="닉네임"
          placeholder="닉네임을 입력해주세요."
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          className="my-3"
          value={myName}
          onChange={(e) => setMyName(e.target.value)}
        />
      </div>
      <div className="my-3">
        {/* 전화번호 */}
        <TextMaskCustom myPhone={myPhone} setMyPhone={setMyPhone} />
      </div>
      {/* 정보 변경 */}
      <div className="center">
        <button className="btn glass_in_btn" onClick={() => setModalVisible(true)}>
          적용하기
        </button>
      </div>
      {/* 모달 */}
      <Modal visible={modalVisible} width="400" height="210" effect="fadeInUp" onClickAway={() => closeModal()}>
        <div className="aiso-modal">
          <div className="aiso-modal-header">
            <button className="btn btn-text-grayPrimary p-3" onClick={() => setModalVisible(false)}>
              <i className="ti-close font-bold"></i>
            </button>
          </div>
          <div className="aiso-modal-body text-center">
            <h3 className="text-xl font-bold text-primary mb-0" id="modal-title">
              적용 하시겠습니까?
            </h3>
            <div className="mt-2">
              <p className="text-xs text-gray-500">적용을 원하시면 확인 버튼을 눌러주세요.</p>
            </div>
          </div>
          <div className="aiso-modal-footer text-center">
            <button type="button" className="btn btn-modal-o w-1/3" onClick={() => handleModalOkButton()}>
              확인
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Profile;
